/**
 * i18n の型定義。3 言語（ja / en / vi）共通のメッセージカタログ + 読み上げスクリプト。
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business voice-enrollment Web の i18n 型定義と言語コード allowlist
 * @graph-connects none
 */

export type LanguageCode = 'ja' | 'en' | 'vi';

/** @graph-connects none */
export const LANGUAGES: readonly LanguageCode[] = ['ja', 'en', 'vi'] as const;

export interface ReadingScript {
  /** スクリプト識別子（embedding メタデータに残す） */
  id: string;
  /** 読み上げ対象テキスト */
  text: string;
  /** 推定読み上げ時間（秒）。UI 表示と最低長検証に使う */
  estimatedSeconds: number;
}

export interface MessagesCatalog {
  appTitle: string;
  consent: {
    title: string;
    summary: string;
    items: string[];
    agreeLabel: string;
    declineLabel: string;
  };
  languageSelect: {
    title: string;
    description: string;
    languageNames: Record<LanguageCode, string>;
    confirm: string;
  };
  recording: {
    title: string;
    instruction: string;
    progressLabel: string;
    startLabel: string;
    stopLabel: string;
    retakeLabel: string;
    nextLabel: string;
    submitLabel: string;
    qualityIssue: string;
    qualityHint: string;
    recordHint: string;
    checkHint: string;
    readyHint: string;
    retryHint: string;
  };
  result: {
    successTitle: string;
    successDescription: string;
    failureTitle: string;
    failureDescription: string;
    backLabel: string;
  };
}

export interface LocaleBundle {
  messages: MessagesCatalog;
  readingScripts: readonly ReadingScript[];
}
